import {createStore, withProps} from '@ngneat/elf';
import {withEntities, withUIEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';

import {
  PurchaseStatement,
  PurchaseStatementsFilters,
  PurchaseStatementUI
} from '@store/invoices/purchaseStatements/purchaseStatements.model';
import {GridSortItem} from '@mui/x-data-grid-pro';
import {TablePagination} from '@store/common/pagination.model';
import {TableConfig} from '@constants/table.constants';

export interface PurchaseStatementsState {
  filters: PurchaseStatementsFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const purchaseStatementsStore = createStore(
  {name: 'purchase-statements'},
  withProps<PurchaseStatementsState>({
    filters: {
      search: '',
      filterAccountantTransferred: false,
      tableFilters: PurchaseStatementsFilters.initTableFilters(),
    },
    sort: {
      field: 'supplierInvoice.invoiceDate',
      sort: 'desc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<PurchaseStatement>(),
  withUIEntities<PurchaseStatementUI>(),
  withPagination(),
  withRequestsStatus(),
);
